var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"castListWrap"},[(!_vm.isLoading)?_c('div',[_c('mtesList',{attrs:{"items":_vm.cast,"listName":'演員列表',"type":"star","showLessNumber":10}})],1):_c('div',{staticStyle:{"height":"50vh"}},[_c('Spinner')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }